'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionCorrespondences', ['$scope', 'Correspondences', function ($scope, Correspondences) {
        $scope.resetInspection();
        $scope.bulkActionItems = [];
        $scope.bulkActionRunning = false;

        $scope.downloadZIP = function (bulkActionItemIds, bulkApply) {
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;

            if (!bulkActionItemIds || bulkActionItemIds.length === 0 || bulkActionItemIds.length > 50) {
                $scope.bulkActionRunning = false;
                alert("Please select between 1 and 50 correspondences");
            }
            else {
                Correspondences.downloadZIP(bulkActionItemIds).then(function (data) {
                    data = "data:text/plain;base64," + data;
                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "download.zip";
                    link.click();

                    $scope.bulkActionRunning = false;
                });
            }
        }

        $scope.columns = [
            {
                label: 'Subject',
                field: 'subject',
                link: {
                    state: 'internal.inspecting.inspection.correspondence',
                    params: [
                        {
                            name: 'inspectionCorrespondenceID',
                            field: 'id'
                        },
                        {
                            name: 'inspection_correspondence',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];
    }])
;